import * as JobCodes from './JobCodes';

const DOTCoordinatorJobCodes = [
    JobCodes.FLEET_SAFETY_SPECIALIST_COMPLIANCE,
    JobCodes.FLEET_SAFETY_SPECIALIST_DOT,
];

const DOTEditorJobCodes = [
    JobCodes.FIELD_ENGINEER,
    JobCodes.PROJECT_CONSTRUCTION_COORDINATOR,
    JobCodes.PROJECT_ENGINEER,
    JobCodes.SENIOR_SITE_INVENTORY_SPECIALIST,
    JobCodes.SITE_INVENTORY_SPECIALIST,
];

const PMSMJobCodes = [
    JobCodes.PROJECT_MANAGER,
    JobCodes.SITE_MANAGER,
    JobCodes.PROJECT_MANAGER_II,
    JobCodes.SENIOR_PROJECT_MANAGER,
];

export {
    DOTCoordinatorJobCodes,
    DOTEditorJobCodes,
    PMSMJobCodes,
}